import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function TaskTable({ task }) {

    if (!task) {
        return <p><em>Loading task information..</em></p>
    }

    if (task.error) {
        return <p><em>{task.error} So no additional task information can be displayed at this time.</em></p>
    }

    return (
        <Container>
            <h5 className="fw-bold mb-3">{task.task}</h5>
            <hr />
            <Row className="mb-3">
                <Col xs={6} lg={2} className="text-muted">Order</Col>
                <Col xs={6} lg={2}>{task.orderNumber}</Col>

                <Col xs={6} lg={2} className="text-muted">Source</Col>
                <Col xs={6} lg={2}>{task.sources}</Col>

                <Col xs={6} lg={2} className="text-muted">Destination</Col>
                <Col xs={6} lg={2}>{task.destinations}</Col>
            </Row>
            <hr />
            <Row className="mb-3">
                <Col xs={6} lg={2} className="text-muted">Type</Col>
                <Col xs={6} lg={2}>{task.taskType}</Col>

                <Col xs={6} lg={2} className="text-muted">Material</Col>
                <Col xs={6} lg={2}>{task.material}</Col>

                <Col xs={6} lg={2} className="text-muted">Status</Col>
                <Col xs={6} lg={2}>{task.status}</Col>
            </Row>
            <hr />
            <Row>
                <Col xs={6} lg={2} className="text-muted">Flow Target</Col>
                <Col xs={6} lg={2}>{task.targetFlow}</Col>

                <Col xs={6} lg={2} className="text-muted">Volume Target</Col>
                <Col xs={6} lg={2}>{task.targetVolume}</Col>
            </Row>
            <hr />
        </Container>
    );
}

export default TaskTable;